module.exports = __webpack_public_path__ + "img/zs.fcd040d8.png";